import { Plugin } from 'chart.js';
import ChartDataLabels, { Context } from 'chartjs-plugin-datalabels';
import React from 'react';
import { PolarArea } from 'react-chartjs-2';

interface PolarAreaProps {
  labels?: string[];
  data?: number[];
  backgroundColor?: string[];
  labelFontSize?: number;
  maxValue?: number;
}

const PolarAreaChartWithLabel: React.FC<PolarAreaProps> = ({
  labels,
  data,
  backgroundColor,
  labelFontSize = 12,
  maxValue = 100,
}) => {
  const mockData: number[] = [];
  data?.forEach(() => {
    mockData.push(maxValue);
  });

  const chartData = {
    labels,
    datasets: [
      {
        label: 'Nota',
        data,
        backgroundColor,
        borderWidth: 1,
        datalabels: {
          offset: 3,
        },
      },
      // Dataset to show the label names outside the chart
      {
        label: 'Atributo',
        data: mockData,
        backgroundColor: 'rgba(0,0,0,0)', // Transparent
        borderWidth: 1,
        borderColor: 'lightgrey',
        datalabels: {
          offset: 26,
          font: { size: labelFontSize },
          formatter(_: unknown, context: Context) {
            return context.chart.data.labels ? context.chart.data.labels[context.dataIndex] : null;
          },
        },
      },
    ],
  };

  return (
    <PolarArea
      data={chartData}
      plugins={[ChartDataLabels as Plugin<'polarArea'>]}
      options={{
        plugins: {
          legend: { display: false },
          datalabels: {
            anchor: 'end',
            align: 'end',
            color: 'black',
            formatter: Math.round,
          },
          tooltip: {
            enabled: false,
          },
        },
        scales: {
          r: {
            ticks: {
              display: false,
            },
          },
        },
        layout: {
          padding: {
            left: 127,
            right: 153,
          },
        },
      }}
    />
  );
};

export default PolarAreaChartWithLabel;
